module.exports = __webpack_public_path__ + "static/media/triggerreminder.a1c3ee70.svg";